import { schemes, zSchema } from "@zeal/common";

export const updateBusinessCardsRequestSchema = zSchema.object({
  companyID: schemes.uuid(),
  customerAccountID: schemes.uuid(),
  businessCardID: schemes.uuid(),
  autoCharge: zSchema.boolean(),
  testMode: zSchema.boolean().optional(),
});

export type TUpdateBusinessCardsRequestSchema = zSchema.infer<
  typeof updateBusinessCardsRequestSchema
>;

export const updateBusinessCardsResponseSchema = zSchema.object({
  businessCardID: schemes.uuid(),
  companyID: schemes.uuid(),
  customerAccountID: schemes.uuid(),
  exp_date: zSchema.string(),
  last_four: zSchema.string(),
  card_company: zSchema.string(),
  auto_charge: zSchema.boolean(),
  status: zSchema.string(),
});

export type TUpdateBusinessCardsResponseSchema = zSchema.infer<
  typeof updateBusinessCardsResponseSchema
>;
